import ScrollCard from './ScrollCard';

export default ScrollCard;
